<template>
  <div class="homePage systemManagement">
      <headerBlank />
    <div class="main-con">

      <router-view></router-view>

    </div>

  </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import headerBlank from "./components/headerBlank";

export default {
  name: "HomePage",
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  watch: {},
  components: {
    headerBlank
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.homePage {
}
.homePage {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.main-con{
  width: 100%;
  height: calc(100% - 28px);
}
</style>
